<template>
    <div class="moving-arrow" :style="arrowStyle"></div>
</template>
<script>
export default {
    props: {
        moveY: {
            type: Number,
            default: 0,
        },
    },
    computed: {
        /**
         * Styles to animate the arrow
         * @returns {{transform: string}}
         */
        arrowStyle() {
            return {
                // moveY 是目標中心點，這裡再 -50% 置中
                transform: `translate3d(0px, ${this.moveY}px, 0px) translateY(-50%)`,
            };
        },
    },
};
</script>
<style lang="scss">
$bg-nude: #f4f3ef !default;

.moving-arrow {
    border-right: 17px solid $bg-nude;
    border-top: 17px solid transparent;
    border-bottom: 17px solid transparent;
    position: absolute;
    left: 243px;
    top: 0;
    /* 這裡不再覆蓋 transform，交給 inline style */
    transition: transform 0.35s cubic-bezier(0.29, 1.42, 0.79, 1);
    will-change: transform;
}
@media (max-width: 992px) {
    .moving-arrow {
        display: none;
    }
}
</style>
